/* app/js/src/components/common/sideNav/sidebar-nav.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  background-color: #ffffff;
  z-index: 10;
}
.active-item,
nav ul li div.active,
nav ul li div:hover {
  color: #232f3a;
}
.active-item ::ng-deep svg path,
nav ul li div.active ::ng-deep svg path,
nav ul li div:hover ::ng-deep svg path {
  fill: #232f3a !important;
}
nav {
  width: 75px;
  background-color: #ffffff;
}
nav ul {
  padding: 0;
  margin: 0;
}
nav ul li,
nav ul li div {
  position: relative;
  display: block;
}
nav ul li div {
  height: 75px;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 600;
  color: #879baf;
  cursor: pointer;
  text-decoration: none;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
nav ul li div i,
nav ul li div span {
  display: block;
}
nav ul li div ::ng-deep svg path {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  fill: #879baf !important;
}
nav ul li div span {
  margin-top: 5px;
  padding: 0 3px;
}
nav ul li div::after {
  content: " ";
}
nav ul li div.active {
  background-color: #eef2f6;
}
nav ul li > svg {
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 105%;
  height: 10px;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromTop;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromTop;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromTop;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: fadeInFromTop;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
nav ul li > svg path {
  fill: #eef2f6;
}
nav ul li > svg.topSvg {
  bottom: auto;
  top: -5px;
  right: -6px;
  left: auto;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromBottom;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromBottom;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromBottom;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: fadeInFromBottom;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
nav ul li:first-child .topSvg {
  display: none !important;
}
[ng-reflect-hidden=true] {
  display: none !important;
}
/*# sourceMappingURL=sidebar-nav.component.css.map */
